const MonitoringType = {
    lookup: 32,
    tacho: {
        corporation: "TachoCorporation",
        private: "TachoPrivate"
    },
    control: {
        VehicleList: 26,
        VehicleHistory: "VehicleHistory",
        VehicleControlList: 27,
        VehicleUpdateList: 28,
        VehicleSWUpdateList: "VehicleSWUpdateList",
        FirmwareUpdateExpansion: 30,
        SoftwareUpdateExpansion: "SoftwareUpdateExpansion",

        VehicleControl: "VehicleControl",
        FirmwareManagement: 31,
        VehicleUpdate: 29,
        VehicleSWUpdate: "VehicleSWUpdate",

        CityBoundaryManagement: 32,
        SoftwareManagement: "SoftwareManagement",
        PriceManagement: "PriceManagement",
    },
    monitoring: {
        lookup: "lookup",
        tacho: "tacho",
        control: "control"
    },
}

export default MonitoringType